define('app-Forms/settings',[],function () {
    return {
        container: ".formContainer",
        watchFields: $("#FirstName, #Surname, #Address1, #DateSelection select, #EmailAddress"),

        //Customer Detail Selectors
        title: $("select[name='Title']"),
        firstName: $("#FirstName"),
        lastName: $("#Surname"),
        telephoneNumber: $("#HomeTelephone"),
        mobileAltNumber: $("#MobileTelephone"),
        emailAddress: $("#EmailAddress"),
        address1: $("#Address1"),
        address2: $("#Address2"),
        town: $("#Town"),
        county: $("#County"),
        postcode: $("#PostCode, #hPostCode"),
        uprn: $('#uprn'),
        udprn: $('#udprn'),
        day: $("select[name='Date of Birth_Days']"),
        month: $("select[name='Date of Birth_Months']"),
        year: $("select[name='Date of Birth_Years']")
    };
});
